import React from "react";

function ServerDownPage() {

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        background:
          "linear-gradient(to right, #fff7ed, #ffedd5)",
      }}
    >

      <div
        className="card border-0 shadow-lg text-center p-5"
        style={{
          maxWidth: "600px",
          borderRadius: "28px",
          background:
            "rgba(255,255,255,0.9)",
          backdropFilter: "blur(10px)",
        }}
      >

        <div className="mb-4">

          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle bg-warning bg-opacity-25"
            style={{
              width: "120px",
              height: "120px",
            }}
          >

            <span
              style={{
                fontSize: "60px",
              }}
            >
              ⚠️
            </span>

          </div>

        </div>

        <h1 className="fw-bold mb-3 text-dark">
          Server Temporarily Down
        </h1>

        <p
          className="text-muted fs-5 mb-4"
          style={{
            lineHeight: "1.8",
          }}
        >
          Service Available: 10AM to 9PM
          <br />
          If facing same problem, Contact Administrator.
        </p>

        <button
          className="btn btn-warning btn-lg rounded-pill px-5 fw-semibold"
          onClick={() =>
            window.location.reload()
          }
        >
          Retry
        </button>

      </div>

    </div>
  );
}

export default ServerDownPage;